import React from "react";
import { useNavigate } from "react-router-dom";

function Logo() {
  const navigate = useNavigate();
  
  return (
    <img 
      src="/image/BeyondSchool.png" 
      alt="BeyondSchool" 
      className="header-logo-size" 
      onClick={() => navigate("/")}
    />
  );
}

export default Logo;